import axios from "axios";
import { useState, useEffect } from "react";
import { Col, Row, Collapse, Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../../App";
import '../../styles/years.css'; // تأكد من أن هذا المسار صحيح
import ScrollTopButton from "../ScrollTop";
import CardNot from "../Cardnotlogin";
import BrianAnimated from "../BrainAnimated";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faChevronDown, faChevronUp, faThumbtack } from "@fortawesome/free-solid-svg-icons";
import GrassAnimation from "../GrassAnimation";
import StonesLoader from "../Stones";
import BinocularsLoader from "../BinocularsLoader";

// === مكون القسم القابل للطي (Accordion) مع التعديل الجديد ===
const CategorySection = ({ categoryItem, type, style }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => setIsOpen(!isOpen);

  if (!categoryItem.courses || categoryItem.courses.length === 0) {
    return null;
  }

  return (
    <>
    {/* <div className="grass">
        <GrassAnimation />
    </div> */}
    <div className="category-accordion">
      <div className="category-header" onClick={toggleOpen}>
        <h3 className="category-title">
          <FontAwesomeIcon icon={faBook} className="pushpin-icon" />
          {categoryItem.category.name}
        </h3>
        <button type="button" className="toggle-button">
          <span>{isOpen ? 'أخفيلي المحتويات' : 'اعرضلي المحتويات'}</span>
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </button>
      </div>
      <Collapse in={isOpen}>
        {/* هذا هو التعديل الهام لإضافة الحاوية الجديدة */}
        <div className="courses-wrapper">
          <Row>
            {categoryItem.courses.map((course) => (
              <Col lg={4} md={6} className="mb-5" key={`${type}-${course.id}`}>
                <CardNot cardonline={course} style={style} />
              </Col>
            ))}
          </Row>
        </div>
      </Collapse>
    </div>
    </>
  );
};


// === المكون الرئيسي للصفحة (لا تغيير في المنطق) ===
function Courses({ style }) {
  const [onlineData, setOnlineData] = useState(null);
  const [centerData, setCenterData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();

  useEffect(() => {
    // الكود هنا كما هو بدون تغيير
    window.scrollTo(0, 0);
    const fetchData = async () => {
      setIsLoading(true);
      const token = localStorage.getItem('token');
      const config = { headers: { 'Content-Type': 'application/json', "ngrok-skip-browser-warning": "any", 'Authorization': `Bearer ${token}` } };
      try {
        const delay = new Promise(resolve => setTimeout(resolve, 2000));
        const onlineResPromise = axios.get(`${BASE_URL}/api/show-level-online-courses/${id}`, config);
        const centerResPromise = axios.get(`${BASE_URL}/api/show-level-offline-courses/${id}`, config);
        const [onlineRes, centerRes] = await Promise.all([onlineResPromise, centerResPromise, delay]);
        setOnlineData(onlineRes.data.data || { categories: [] });
        if (centerRes) setCenterData(centerRes.data.data || { categories: [] });
      } catch (error) {
        console.error("Failed to fetch courses", error);
        setOnlineData({ categories: [] });
        setCenterData({ categories: [] });
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (isLoading) {
    return (
      <div className={`main-loading ${style ? 'dark-mode' : ''}`}>
        <div className="loading-course">
          {/* <BrianAnimated /> */}
          <BrianAnimated style={style} />
        </div>
      </div>
    );
  }


  const hasOnlineContent = onlineData?.categories?.some(c => c.courses?.length > 0);
  const hasCenterContent = centerData?.categories?.some(c => c.courses?.length > 0);

  return (
    <>
      <div className={`courses-page-content ${style ? 'dark-mode' : ''}`}>
        {/* <Container> */}
          <div className="title-section">
            <h2>كورسات الأونلاين</h2>
          </div>
          {hasOnlineContent ? (
            onlineData.categories.map((catItem) => (
              <CategorySection key={`online-cat-${catItem.category.id}`} categoryItem={catItem} type="online" style={style} />
            ))
          ) : (
            <div className="no-content-container">
  <div className="icon-wrapper-not">
    <span className="icon-line line-1"></span>
    <span className="icon-line line-2"></span>
  </div>
      <h2>لا توجد كورسات أون لاين حالياً</h2>
              <p>! سيتم اضافة الكورسات قريبا , تابعنا</p>
</div>
          )}

          
        
              <div className="title-section" style={{marginTop: '80px'}}>
                <h2>كورسات السنتر</h2>
              </div>
              {hasCenterContent ? (
                centerData.categories.map((catItem) => (
                  <CategorySection key={`center-cat-${catItem.category.id}`} categoryItem={catItem} type="center" style={style} />
                ))
              ) : (
                <div className="no-content-container">
  <div className="icon-wrapper-not">
    <span className="icon-line line-1"></span>
    <span className="icon-line line-2"></span>
  </div>
      <h2>لا توجد كورسات  سنتر حالياً</h2>
              <p>! سيتم اضافة الكورسات قريبا , تابعنا</p>
</div>
              )}
         
        {/* </Container> */}
      </div>
      <ScrollTopButton />
    </>
  );
}

export default Courses;